var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44444 13.5H16.5556C17.075 13.5 17.5 13.0125 17.5 12.4167C17.5 11.8208 17.075 11.3333 16.5556 11.3333H1.44444C0.925 11.3333 0.5 11.8208 0.5 12.4167C0.5 13.0125 0.925 13.5 1.44444 13.5ZM1.44444 8.08333H16.5556C17.075 8.08333 17.5 7.59583 17.5 7C17.5 6.40417 17.075 5.91667 16.5556 5.91667H1.44444C0.925 5.91667 0.5 6.40417 0.5 7C0.5 7.59583 0.925 8.08333 1.44444 8.08333ZM0.5 1.58333C0.5 2.17917 0.925 2.66667 1.44444 2.66667H16.5556C17.075 2.66667 17.5 2.17917 17.5 1.58333C17.5 0.9875 17.075 0.5 16.5556 0.5H1.44444C0.925 0.5 0.5 0.9875 0.5 1.58333Z",
    fill: "#EEF4FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleNav);
export default __webpack_public_path__ + "static/media/toggle_nav.2dad3549bf653ae4367e85c59d9ba8ef.svg";
export { ForwardRef as ReactComponent };